import Adventures from "./adventures";

export default Adventures;
